import React, { Component } from 'react';
import cx from 'classnames';

// Components
import Pictogram from './pictogram';
import TranslatedCopy from '../../intl/translated-copy';
import { getCMSUrl } from '../../constants/cms-urls';

class HeaderMenuBook extends Component {
  render() {
    const {
      storefront,
    } = this.props;
    const [ 
      language,
      country,
    ] = storefront.split('-');

    const bookClasses = cx({
      'HeaderMenuBook': true,
      'HeaderMenuBook--advancedBooking': false,
    });
    return (
      <div className={ bookClasses }>
        <ul className='HeaderMenuBook-itemList'>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                href={ getCMSUrl(country, language, 'BOOK') }
                target='_blank'
                className='HeaderMenuBook-link HeaderMenuBook-link--flight'
                rel='noopener noreferrer'>
                <div className='HeaderMenuBook-content'>
                  <Pictogram className='HeaderMenuBook-itemIcon' id='flight' />
                  <TranslatedCopy
                    className='HeaderMenuBook-itemTitle'
                    copyID='APP_FLIGHTS' />
                </div>
              </a>
            </div>
          </li>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                target='_blank'
                href={ 'https://www.granplan.com/' }
                rel='noopener noreferrer'>
                <div className='HeaderMenuBook-content'>
                  <Pictogram className='HeaderMenuBook-itemIcon' id='vacation' />
                  <div className='HeaderMenuBook-wrapCopy'>
                    <TranslatedCopy
                      className='HeaderMenuBook-itemTitle'
                      copyID='APP_VACATIONS' />
                  </div>
                </div>
              </a>
            </div>
          </li>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                target='_blank'
                href='https://www.granplan.com/'
                rel='noopener noreferrer'>
                <div className='HeaderMenuBook-content'>
                  <Pictogram className='HeaderMenuBook-itemIcon' id='hotel' />
                  <TranslatedCopy
                    className='HeaderMenuBook-itemTitle'
                    copyID='APP_HOTELS' />
                </div>
              </a>
            </div>
          </li>
          <li>
            <div className='HeaderMenuBook-item'>
              <a
                className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
                href='https://www.granplan.com/'
                target='_blank'
                rel='noopener noreferrer'>
                <div className='HeaderMenuBook-content'>
                  <Pictogram className='HeaderMenuBook-itemIcon' id='car' />
                  <TranslatedCopy
                    className='HeaderMenuBook-itemTitle'
                    copyID='APP_CARS' />
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default HeaderMenuBook;
